import { DeepPartial, ResultComponentsConfig, SLOTS } from '@empathybroker/ebx-gluon';

export const DESKTOP_RESULTS_CONFIG: DeepPartial<ResultComponentsConfig> = {
 /*template: {
  children: {
      add2cart: {
        component: 'GoccoAdd2CartButton',
        data: {
          slot: SLOTS.result.footer
        }
      }
    }
  }*/
};
